import React, { useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { PaymentHistoryItemSchema } from '../../data/types';
// import { PaymentMethod } from "@stripe/stripe-js";

import PaymentHistoryRecord from "../../components/Desktop/PaymentHistoryRecord";
import PaymentHistorySkeleton from "../../components/PaymentHistorySkeleton";
// import moment from "moment";
// import { useGetPaymentMethods } from "../hooks/paymenthooks";
// import { useCompleteSignIn } from "../hooks/authhooks";
  // import Pagination from "../components/Pagination";


type PaymentHistoryProps = {
  paymentHistoryList: PaymentHistoryItemSchema[];
  /** When true, shows an aesthetic table skeleton instead of the list */
  isLoading?: boolean;
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ paymentHistoryList, isLoading = false }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(paymentHistoryList.length / itemsPerPage);
  const startIndex: number = (currentPage - 1) * itemsPerPage;
  const endIndex: number = Math.min(startIndex + itemsPerPage, paymentHistoryList.length);
  const currentPaymentHistoryList = paymentHistoryList.slice(startIndex, endIndex);

  if (isLoading) {
    return <PaymentHistorySkeleton variant="desktop" />;
  }

  // console.log("currentPaymentHistoryList: ", currentPaymentHistoryList)


  // const { user } = useCompleteSignIn();
  // const loggedinUid = (user && user?.uid) ? user.uid : '';
  // console.log("loggedinUid: ", loggedinUid)




  // var { paymentMethods } = useGetPaymentMethods(loggedinUid);
  // paymentMethods = (paymentMethods && Array.isArray(paymentMethods)) ? paymentMethods : [];

  // Create a map of paymentMethods with id as key and paymentMethod object as value
  // const paymentMethodsMap: { [id: string]: PaymentMethod } = {};
  // if (paymentMethods && Array.isArray(paymentMethods)){
  // paymentMethods?.forEach((pm: PaymentMethod) => {
  //   if (pm && pm.id) {
  //       paymentMethodsMap[pm.id] = pm;
  //     }
  //   });
  // }

  // const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
  //   (paymentMethods && paymentMethods.length > 0) ? paymentMethods.find((p: PaymentMethod) => p.id === currentPaymentHistoryList[0]?.payment_method) || paymentMethods[0] : {} as PaymentMethod
  // );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // const getStatusColor = (status: string) => {
  //   switch (status) {
  //     case 'completed':
  //       return 'text-green-600';
  //     case 'pending':
  //       return 'text-orange-600';
  //     case 'refunded':
  //       return 'text-blue-600';
  //     case 'failed':
  //       return 'text-red-600';
  //     default:
  //       return 'text-gray-600';
  //   }
  // };

  // const getStatusDotColor = (status: string) => {
  //   switch (status) {
  //     case 'completed':
  //       return 'text-green-600';
  //     case 'pending':
  //       return 'text-orange-600';
  //     case 'refunded':
  //       return 'text-blue-600';
  //     case 'failed':
  //       return 'text-red-600';
  //     default:
  //       return 'text-gray-600';
  //   }
  // };

  // const getPaymentMethodIcon = (paymentMethod: string) => {
  //   if (paymentMethod){
  //   switch (paymentMethod.toLowerCase()) {
  //     case 'master card':
  //     case 'mastercard':
  //       return <MasterCardIcon className="w-6 h-6 mr-2" />;
  //       default:
  //         return <div className="w-6 h-6 bg-gray-300 rounded-full mr-2"></div>;
  //     }
  //   }
  //   return <></>
  //   // return <div className="w-6 h-6 bg-gray-300 rounded-full mr-2"></div>;
  // };

  // console.log("paymentMethods: ", paymentMethods)
  // console.log("paymentHistoryList: ", paymentHistoryList)
  // console.log("currentPaymentHistoryList[0]: ", currentPaymentHistoryList ? currentPaymentHistoryList[0]?.payment_method : '')


  // const getCardIcon = (paymentMethod: string) => {
  //   switch (paymentMethod) {
  //     case 'visa':
  //       return <VisaCardIcon className='w-8 my-auto' />;
  //     case 'mastercard':
  //       return <MasterCardIcon className='w-8 my-auto' />;
  //     case 'amex':
  //       return <AmexCardIcon className='w-8 my-auto' />;
  //     case 'discover':
  //       return <DiscoverCardIcon className='w-8 my-auto' />
  //     case 'cashapp':
  //       return <CashappIcon className='w-8 h-8 my-auto' />
  //     case 'amazon_pay':
  //       return <AmazonPayIcon className='w-8 h-6 my-auto' />
  //     default:
  //       return <img src="/icons/unknown.svg" alt="Unknown" />;
  //   }
  // };

  return (
    <div className="bg-white rounded-lg shadow-sm">
      {/* Header Section */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <div className="text-sm text-gray-600">
          Showing {(startIndex >= 0 && paymentHistoryList.length > 0) ? startIndex + 1 : 0} - {endIndex} of {paymentHistoryList.length} Transactions
        </div>
        
        <div className="flex items-center space-x-4">
          {/* Search Bar */}
          {/* <div className="relative">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" style={{ fontSize: 20 }} />
            <input
              type="text"
              placeholder="Search for resource name"
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryDark-300 focus:border-transparent"
              style={{ width: '250px' }}
            />
          </div> */}
          
          {/* Filter Button */}
          {/* <button className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
            <FilterListIcon style={{ fontSize: 20 }} />
            <span>Filter</span>
          </button> */}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                S/N
              </th> */}
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Resource Name
              </th> */}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Payment Method
              </th>
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Transaction Date
              </th> */}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Transaction Id
              </th>
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date
              </th> */}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th> */}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentPaymentHistoryList.map((item, index) => (
              <PaymentHistoryRecord paymentHistoryItem={item} key={index}/>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {paymentHistoryList.length > itemsPerPage && (
        <div className="px-6 py-4 border-t border-gray-200">
          <div className="flex items-center justify-center space-x-2">
            <button
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentPage === 1 
                  ? 'bg-primaryDark-300 text-white border-[#E9E9E9]/50' 
                  : 'bg-white text-gray-700 border border-[#E9E9E9] hover:bg-gray-50'
              }`}
              onClick={() => handlePageChange(1)}
            >
              1
            </button>
            <button
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentPage === 2 
                  ? 'bg-primaryDark-300 text-white border-[#E9E9E9]/50' 
                  : 'bg-white text-gray-700 border border-[#E9E9E9] hover:bg-gray-50'
              }`}
              onClick={() => handlePageChange(2)}
            >
              2
            </button>
            <button
              className="ml-4 px-3 py-1 text-sm text-primaryDark-200 hover:text-primary-600 border-[#E9E9E9] font-semibold border-[1px] rounded-lg"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Next &gt;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentHistory;
